module.exports = __webpack_public_path__ + "static/media/Portrait-10198.72406d38.jpg";